module.exports = __webpack_public_path__ + "img/ts-100x140.4e12c3dd.jpg";